// ============================================================
// Global axios configuration for RE₿EL BTC.
//
// We DO NOT touch `withCredentials` globally — existing code paths
// rely on per-call settings (some need cookies for same-origin
// httpOnly auth). Instead we only:
//
//   • Add an Authorization: Bearer <jwt> from localStorage to every
//     request as a SAFE FALLBACK for cross-origin scenarios where
//     cookies can't reach the backend (e.g. rebelbtc.com → Emergent).
//
//   • Individual callers may explicitly set `withCredentials: false`
//     when they need the CORS preflight to pass with Allow-Origin:*.
//     The Bearer header is enough to authenticate them.
//
// Importing this module once at app startup (index.js) applies the
// Bearer interceptor to every axios call in the codebase.
// ============================================================
import axios from "axios";

const TOKEN_KEY = "rebel_jwt";

// Attach Bearer automatically. We do NOT throw if there's no token —
// callers handle 401 themselves. We also do NOT change the global
// `withCredentials` default to avoid breaking existing cookie-based flows.
axios.interceptors.request.use(
  (config) => {
    try {
      const token = window.localStorage?.getItem(TOKEN_KEY);
      if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch {
      // ignore (SSR / private mode)
    }
    return config;
  },
  (err) => Promise.reject(err)
);

export default axios;
